import React from "react";
// import imageUpload from "assets/svgs/imageUpload.svg";
// import removeImg from "assets/svgs/close.svg";
import server from "../../api/server";
import { useEffect } from "react";
import { Col } from "reactstrap";
import { useRef } from "react";
// import server from 'api/server';

const ImagesUpload = ({ selectedImage, setSelectedImage }) => {
	const input = useRef();
	useEffect(() => {
		if (!selectedImage?.length > 0) {
			setSelectedImage([selectedImage]);
		}
	}, [selectedImage, setSelectedImage]);

	const imageChange = async e => {
		if (e.target.files && e.target.files.length > 0) {
			let images = await Promise.all(
				[...e?.target?.files]?.map(async e => {
					const formData = new FormData();
					formData.append("file", e);
					const { data } = await server().post("/upload", formData);
					return {
						path: data.data?.file?.fullpath,
					};
				})
			);

			setSelectedImage([...images, ...selectedImage]);
		}
		input.current.value = "";
	};

	const removeSelectedImage = index => {
		setSelectedImage(selectedImage?.filter((e, i) => i !== index));
	};

	return (
		<div className="image-uploader h-auto image-contain w-auto">
			<div
				className="img-pat d-flex justify-content-evenly align-items-center my-2"
				style={{ maxWidth: "160px" }}
			>
				الصور
				<i className="fas fa-images"></i>
			</div>
			<label className="w-100">
				{((selectedImage?.length && selectedImage) || [])?.map(
					(image, index) =>
						image?.path && (
							<div className="d-inline-block w-auto mx-2" key={index}>
								<img src={image?.path || ""} width={160} height={160} alt="" />
								<span
									className="removeImg"
									onClick={e => {
										e?.preventDefault();
										removeSelectedImage(index);
									}}
								>
									{/* <img src={removeImg} alt="" /> */}
									<i className="fas fa-trash"></i>
								</span>
							</div>
						)
				)}
				<input
					ref={input}
					accept="image/*"
					type="file"
					onChange={imageChange}
					multiple
				/>
			</label>
		</div>
	);
};

export default ImagesUpload;
